import { render, staticRenderFns } from "./StTeaserDownloadLink.vue?vue&type=template&id=2cd04c70"
import script from "./StTeaserDownloadLink.vue?vue&type=script&lang=ts"
export * from "./StTeaserDownloadLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports